/// <amd-module name="TFS/CreateProject/Components/AdvancedOptions" />
import * as React from "react";
import { IProcessTemplateDescriptor, IProjectCreationMetadataItemDescriptor } from "TFS/CreateProject/Contracts";
import * as CreateProjectResources from "TFS/CreateProject/Resources";
import { getId } from "VSS/Core/Util/Object";
import { IVssLayoutManager, RegionComponent, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";

export interface IAdvancedOptionsProps {
    showAdvancedOptions: boolean;
    disabled: boolean;
    onAdvancedOptionClick: () => void;
    currentVersionControlType: string;
    currentProcessTemplate: string;
    onVersionControlComboOptionChanged: (selectedVersionControlType: string) => void;
    onProcessTemplateComboOptionChanged: (selectedProcessTemplate: string) => void;
}

export class AdvancedOptions extends VssComponent<IAdvancedOptionsProps, {}> {
    private static REGION_NAME = "createProjectAdvancedOptionsRegion";
    private static VERSION_CONTROL_SELECTOR_KEY = "versionControlSelector";
    private static PROCESS_TEMPLATE_SELECTOR_KEY = "processTemplateSelector";
    private _advancedOptionsContainerId = getId("advanced-options-container-id");

    public render(): JSX.Element | null {
        const {
            showAdvancedOptions,
            disabled,
            onAdvancedOptionClick,
            currentVersionControlType,
            currentProcessTemplate,
            onVersionControlComboOptionChanged,
            onProcessTemplateComboOptionChanged
        } = this.props;
        const layoutManager = this.context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        const childComponents = layoutManager.getComponentsForRegion(AdvancedOptions.REGION_NAME);
        const showAdvancedOptionsComponent = childComponents.length > 0;

        return showAdvancedOptionsComponent ? (
            <div className="advanced-options-container">
                <Button
                    className="advanced-options-toggle-button"
                    iconProps={{
                        iconName: showAdvancedOptions ? "ChevronUp" : "ChevronDown",
                        className: "chevron-icon"
                    }}
                    text={CreateProjectResources.CreateProjectAdvancedOptionsText}
                    aria-expanded={showAdvancedOptions}
                    aria-controls={this._advancedOptionsContainerId}
                    disabled={disabled}
                    onClick={onAdvancedOptionClick}
                />
                <div id={this._advancedOptionsContainerId}>
                    {showAdvancedOptions && (
                        <RegionComponent
                            className="advanced-options-region flex"
                            componentRegion={AdvancedOptions.REGION_NAME}
                            childComponentProperties={{
                                className: "options-selector",
                                onSelectedOptionChanged: this._onSelectedOptionChanged,
                                initialOptions: this._getInitialOptions(),
                                disabled: disabled
                            }}
                        />
                    )}
                </div>
            </div>
        ) : null;
    }

    private _onSelectedOptionChanged = (key: string, value: string): void => {
        if (key === AdvancedOptions.VERSION_CONTROL_SELECTOR_KEY) {
            this.props.onVersionControlComboOptionChanged(value);
        } else if (key === AdvancedOptions.PROCESS_TEMPLATE_SELECTOR_KEY) {
            this.props.onProcessTemplateComboOptionChanged(value);
        }
    };

    private _getInitialOptions = (): { [key: string]: string } => {
        return {
            [AdvancedOptions.VERSION_CONTROL_SELECTOR_KEY]: this.props.currentVersionControlType,
            [AdvancedOptions.PROCESS_TEMPLATE_SELECTOR_KEY]: this.props.currentProcessTemplate
        };
    };
}
